export default {
  // 自媒体号详细信息接口
  getSelfMediaFreChannel: '/amc/client/getSelfMediaFreChannel',
  // 媒体号文章分类下的文章列表接口
  findContentPageByFreChannelId: '/amc/client/findContentPageByFreChannelId',
  // 查询是否订阅
  isSubscribe: '/amc/client/isSubscribe',
  // 订阅
  subscribeSelfMedia: '/amc/client/subscribeSelfMedia',
  // 取消订阅
  unSubscribeSelfMedia: '/amc/client/unSubscribeSelfMedia',
}